import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeletePackageCategory(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deletePackageCategory = useCallback((packageCategoryId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`package-categories/${packageCategoryId}/`);
  }, []);

  return useMutation(deletePackageCategory, {
    onSuccess: () => {
      queryClient.removeQueries('packageCategories');
      queryClient.invalidateQueries('packages');
    },
  });
}
